import { render, staticRenderFns } from "./MFormVuetifyCombobox.vue?vue&type=template&id=655feccd&scoped=true"
import script from "./MFormVuetifyCombobox.vue?vue&type=script&lang=js"
export * from "./MFormVuetifyCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655feccd",
  null
  
)

export default component.exports